module.exports = __webpack_public_path__ + "img/logout.bde5476e.svg";